export default "__VITE_ASSET__d3e03d4f__"